<template lang="pug">
  reporting-layout
    v-flex(xs12)
      v-container.pa-0(fluid)
        v-layout(row wrap)
          iframe(:src="getUrl" @load="fitToContent" ref="iframe")
          
</template>

<script>
import ReportingLayout from '@/Reporting/Layout';
import FitToContent from '@/Reporting/mixins/FitToContent';
export default {
  mixins: [FitToContent],
  components: {
    ReportingLayout,
  },
  computed: {
    getUrl() {
      return `${process.env.VUE_APP_ADMIN_URL}/reporting_v2_email.html`;
    },
  },
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  border: none;
  min-height: 100vh;
}
</style>
